import React, { useCallback, useContext, useEffect, useState } from 'react'

import { redirectToSSOWithReturnUrl } from 'api/utils'
import { ArticlePageContext } from 'components/pages/article'
import { CSSProperties } from 'styled-components'

import { AskDoctorContext } from './context'
import { Post } from './interfaces/types'
import { MainBody } from './mainBody'
import { PopupWrapper } from './popupWrapper'

export type Props = {
  postCount?: number
  isCommentPopupOpen?: boolean
  handleClose?: () => void
  setPostCount?: (v: number) => void
  style?: CSSProperties
  className?: string
}

const AskDoctor = ({
  postCount = 0,
  isCommentPopupOpen,
  setPostCount,
  handleClose,
  ...rest
}: Props) => {
  const { currentArticle } = useContext(ArticlePageContext)
  const [articleInside, setArticleInside] = useState(currentArticle)
  const [showPostForm, setShowPostForm] = useState(false)
  const [showPostDetailPopup, setShowPostDetailPopup] = useState(false)
  const [selectedPost, setSelectedPost] = useState<Post>()
  const [editPostData, setEditPostData] = useState<Post | undefined>()
  const [loadingData, setLoadingData] = useState()

  const handleRedirectSSO = useCallback(() => {
    redirectToSSOWithReturnUrl(
      `${window.location.origin}${currentArticle?.permalink}`,
      'comment',
    )
  }, [currentArticle])

  useEffect(() => {
    setArticleInside(currentArticle)
  }, [currentArticle])

  useEffect(() => {
    setShowPostForm(false)
    setShowPostDetailPopup(false)
  }, [isCommentPopupOpen])

  const popupProps = {
    article: articleInside,
    isCommentPopupOpen,
    handleClose,
    setPostCount,
  }

  return (
    <PopupWrapper {...popupProps} {...rest}>
      <AskDoctorContext.Provider
        value={{
          article: articleInside,
          selectedPost,
          setSelectedPost,
          showPostDetailPopup,
          setShowPostDetailPopup,
          showPostForm,
          setShowPostForm,
          editPostData,
          setEditPostData,
          handleClosePopup: handleClose,
          handleRedirectSSO,
          setPostCount,
          loadingData,
          setLoadingData,
        }}
      >
        <MainBody postCount={postCount} />
      </AskDoctorContext.Provider>
    </PopupWrapper>
  )
}

export { AskDoctor }
